export const SEND_USER_TO_V2 = 'SEND_USER_TO_V2';
export const sendUserToV2 = () => ({
  type: SEND_USER_TO_V2,
});

export const V3_OPT_OUT_WITHOUT_FEEDBACK = 'V3_OPT_OUT_WITHOUT_FEEDBACK';
export const optOutWithoutFeedback = () => ({
  type: V3_OPT_OUT_WITHOUT_FEEDBACK,
});

export const V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE = 'V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE';
export const optOutWithoutFeedbackFailure = (error) => ({
  type: V3_OPT_OUT_WITHOUT_FEEDBACK_FAILURE,
  error,
});

export const V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS = 'V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS';
export const optOutWithoutFeedbackSuccess = (redirectToV2) => ({
  type: V3_OPT_OUT_WITHOUT_FEEDBACK_SUCCESS,
  redirectToV2,
});
